"use strict";

global.$ = global.jQuery = require('jquery');
global._ = window._ = require('underscore');
global.$.fn.reverse = [].reverse;

window.easings = {};
window.easings.ease = [0.25, 0.46, 0.45, 0.94];
window.easings.andrew = [0.77, 0, 0.175, 1];
window.easings.feebles1 = [.8,.03,.25,1];
window.easings.feebles2 = [.72,.01,.25,1];
window.easings.ease2 = [.48,.1,.48,.9];

var validation = require('jquery-validation');
var PubSub = require("underpub-js");

var Sitewide = require("./classes/Sitewide");
var ComponentsLoader = require("./classes/ComponentsLoader");
//var {Amplify} = require("../../../vendor/authenticff/authentic-amplify/frontend/scripts/main.js");

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function(){
  this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(window).resize(function(){ Breakpoint.refreshValue(); }).resize();

window.SiteWide = {};

// set up our document onload items in a function so we can call it when pjax loads a new page
SiteWide.documentOnLoad = function() {

  var components = [
    // components
    {handle: "[data-header-navigation]", require: require("../components/molecules/navigation/HeaderNavigation/HeaderNavigation")},
    {handle: "[data-mobile-nav-overlay]", require: require("../components/molecules/navigation/MobileNavOverlay/MobileNavOverlay")},
    {handle: "[data-full-width-image-slider]", require: require("../components/molecules/hero/FullWidthImageSlider/FullWidthImageSlider")},
    {handle: "[data-image-gallery-modal]", require: require("../components/molecules/misc/ImageGalleryModal/ImageGalleryModal")},
    {handle: "[data-image-slider-with-text-content]", require: require("../components/molecules/content/imageSliderWithTextContent/ImageSliderWithTextContent")},
  ];


  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({components: components});
  componentsLoader.initScreen();

  // setting our breakpoint value
  Breakpoint.refreshValue();

};

// document ready

$(document).ready(function(){

  // call sitewide here, because we only want to init this once
  var sitewide = new Sitewide();
  sitewide.init();

  SiteWide.documentOnLoad();

});
